<template>
  <ValidationProvider ref="provider" mode="eager" :name="name" :rules="validationRules" v-slot="{ errors, passed }" slim>
  <div class="form-field" :class="{error: errors.length, 'valid': passed && value }">
    <label class="label" :for="name">
      <label v-if="label" class="title" :for="name">{{ label }}<span class="required" v-if="required">*</span></label>
      <span v-if="help" class="help" @click="showHelp = true">?</span>
    </label>
    <SliderField v-if="slider" v-bind:value="value" @input="$emit('input', $event)" :possibleValues="possibleValues"></SliderField>
    <div v-else class="inline space-between top" :name="name">
      <div class="flex item" v-for="possibleValue in possibleValues" :key="possibleValue.value">
        <CheckField
          :value="possibleValue.value"
          :icon="possibleValue.icon"
          v-bind:output="value"
          @change="$emit('input', $event)"
          :radio="radio"
          :round="possibleValue.round || false"
          :label="possibleValue.label"
        ></CheckField>
      </div>
    </div>

    <!-- <div class="error-block"><div class="error-badge"><SvgIcon icon="form-error" fill></SvgIcon></div>{{ errors[0] }}</div> -->
    <Help v-if="help && showHelp" class="help" :help="help" @close="showHelp = false"></Help>
  </div>
  </ValidationProvider>
</template>

<script>
import CheckField from "@/components/Form/SimulationFields/CheckField";
import SliderField from "@/components/Form/SimulationFields/SliderField";
import Help from "@/components/Help.vue";

export default {
  data() {
    return {
      showHelp: false
    }
  },
  props: {
    name: {
      // Form field name - default random
      type: String,
      default: `field-${Math.floor(Math.random() * 1000)}`,
    },
    radio: {
      type: Boolean,
      required: false,
    },
    slider: {
      type: Boolean,
      required: false,
    },
    label: {
      // Label of the field
      type: String,
    },
    required: {
      type: Boolean,
      required: false,
    },
    possibleValues: {
      // Array of object 
      // { label: 'Électricité' value: 'elec', icon: 'elec' }
      type: Array,
      required: true,
    },
    rules: {
      type: String,
      required: false
    },
    help: {
      type: Object,
      required: false,
    },
    value: {},
  },
  computed: {
    validationRules() {
      let rules = this.rules;
      if(this.required) { 
          rules = !rules ? `required` : `required|${rules}`;
      }

      return rules;
    }
  },
  methods: {
  },
  components: {
    CheckField,
    SliderField,
    Help
  },
};
</script>

<style lang="scss" scoped>
.form-field {
  margin: 0 15px;
  margin-bottom: 15px;
  text-align: left;

  .label {
    .title {
      position: relative;
      display: block;
      margin: 0;
      margin-bottom: 5px;
    }
  }

  .item {
    // justify-content: flex-start;
    max-width: 130px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Form/SimulationField.vue